// src/configs/ApplicationStyles.js
import app from './ConfigIndex.js';
import { DARK_MODE } from 'constants/ThemeConstant';
import {
  DEFAULT_BACK_COLOR,
  DEFAULT_BACK_COLOR_ACCENT,
  DEFAULT_BACK_COLOR_ACCENT_DARK,
} from 'constants/Constants';

// Gera CSS para sobrescrever estilos do Ant Design
const generateAntdOverrideCss = (color, theme) => `

  /* Ícones do PageHeader e componentes com .text-primary devem usar cor do sistema */
  /* Quando .text-primary é pai do ícone */
  .text-primary span.anticon svg {
    color: ${theme === 'dark' ? DEFAULT_BACK_COLOR : color};
  }

  /* Quando .text-primary está diretamente no elemento .anticon (ex: prefix de Input) */
  span.anticon.text-primary svg {
    color: ${theme === 'dark' ? DEFAULT_BACK_COLOR : color};
  }

  /* Ícones customizados em messages (appService.message com icon prop) */
  // .ant-message .ant-message-custom-content .anticon svg {
  //   color: ${theme === 'dark' ? DEFAULT_BACK_COLOR : color};
  // }

  .anticon.status-icon-error svg {
    color: #ff4d4f !important;
    fill: #ff4d4f !important;
  }

  .anticon.status-icon-success svg {
    color: #52c41a !important;
    fill: #52c41a !important;
  }

  // button[disabled] {
  //    background-color: ${theme === 'dark' ? DEFAULT_BACK_COLOR_ACCENT_DARK : DEFAULT_BACK_COLOR_ACCENT} !important;
  // }

  /* Fix: Disabled fields border color consistency across themes */
  ${
    theme === 'dark'
      ? `
  /* Dark mode - All disabled fields should use subtle border */
  .ant-input-outlined.ant-input-disabled,
  .ant-input-outlined[disabled],
  .ant-input-affix-wrapper-disabled,
  .ant-input-number-disabled,
  .ant-picker-disabled {
    border-color: rgba(255, 255, 255, 0.2) !important;
  }

  .ant-select.ant-select-outlined.ant-select-disabled {
    --select-border-color: rgba(255, 255, 255, 0.2) !important;
    --select-background: rgba(255, 255, 255, 0.08) !important;
  }
  `
      : `
  /* Light mode - Select disabled border should match Input (#e6ebf1) */
  .ant-select.ant-select-outlined.ant-select-disabled {
    --select-border-color: #e6ebf1 !important;
    --select-background: rgba(0, 0, 0, 0.04) !important;
  }
  `
  }

`;

// Estilo para borda dos cards
const generateCardCss = color => `
  // .ant-card-bordered:not(.no-change-border-color) {
  //   border-color: ${color}40;
  // }
`;

const generateTableCss = color => `
  div.ant-table-wrapper {
    // border: solid 1px ${color}20 !important;
    border: solid 1px #0505050f !important;
    border-radius: 10px !important;
    // box-shadow: 0 1px 4px -1px rgb(0 0 0 / 15%)
  }
`;

// Estilo para o componente avatar com select
const generateFormAvatarCss = color => `
  .avatar-select.board-card-modal .ant-select-selector:hover {
    border-color: ${color} !important;
  }
`;

// Estilo do kanban (coluna nova, hover, drag-over)
const generateKanbanCss = color => `
  .js-css-kanban-new-column {
    background-color: ${color}FF !important;
  }

  .js-css-kanban-new-column:hover,
  .js-css-kanban-new-column.drag-over {
    background-color: ${color}80 !important;
  }
`;

// Estilo do progress da notificação
const generateNotificationProgressCss = color => `
  /* Progress bar da notificação - elemento HTML <progress> nativo */

  /* Remove qualquer background-image que possa estar sobrescrevendo */
  progress.ant-notification-notice-progress {
    background-image: none !important;
  }

  /* Webkit/Blink (Chrome, Safari, Edge, Opera) */
  progress.ant-notification-notice-progress::-webkit-progress-bar {
    background-color: rgba(255, 255, 255, 0.2) !important;
    background-image: none !important;
  }

  progress.ant-notification-notice-progress::-webkit-progress-value {
    background-color: ${color} !important;
    background-image: none !important;
  }

  /* Firefox */
  progress.ant-notification-notice-progress::-moz-progress-bar {
    background-color: ${color} !important;
    background-image: none !important;
  }

  /* Accent color como fallback */
  progress.ant-notification-notice-progress {
    accent-color: ${color} !important;
  }
`;

// Estilo customizado para Steps (mudar cor do azul padrão para a cor da aplicação)
const generateStepsCss = color => `
  /* Sobrescreve variáveis CSS do Ant Design para Steps */
  .ant-steps {
    --ant-color-primary: ${color} !important;
    --ant-color-primary-bg: ${color}20 !important;
    --ant-color-primary-hover: ${color} !important;
    --steps-item-icon-dot-bg-color: ${color} !important;
    --steps-item-solid-line-color: ${color} !important;
  }

  /* Dot do step ativo e concluído */
  .ant-steps-item-process .ant-steps-item-icon,
  .ant-steps-item-finish .ant-steps-item-icon {
    background-color: ${color} !important;
  }

  /* Título do step ativo e concluído */
  .ant-steps-item-process .ant-steps-item-title,
  .ant-steps-item-finish .ant-steps-item-title {
    color: ${color} !important;
  }

  /* Linha de conexão (rail) do step ativo */
  .ant-steps-item-rail.ant-steps-item-rail-process {
    border-color: ${color} !important;
  }

  /* Linha de conexão (tail) do step concluído */
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: ${color} !important;
  }

  /* Linha de conexão (tail) do step atual */
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: ${color} !important;
  }

  /* ============================================= */
  /* Registration Steps - White theme (AuthLayout) */
  /* ============================================= */

  /* WAIT STATE - future steps */
  .registration-steps-white.ant-steps .ant-steps-item-wait .ant-steps-item-icon {
    background: transparent !important;
    border-color: rgba(255, 255, 255, 0.4) !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-wait .ant-steps-item-icon-number {
    color: rgba(255, 255, 255, 0.4) !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-wait .ant-steps-item-title {
    color: rgba(255, 255, 255, 0.5) !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-wait .ant-steps-item-content {
    color: rgba(255, 255, 255, 0.35) !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-wait .ant-steps-item-rail::after {
    background: rgba(255, 255, 255, 0.2) !important;
  }

  /* PROCESS STATE - current active step */
  .registration-steps-white.ant-steps .ant-steps-item-process .ant-steps-item-icon {
    background: #ffffff !important;
    border-color: #ffffff !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-process .ant-steps-item-icon-number {
    color: ${color} !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-process .ant-steps-item-title {
    color: #ffffff !important;
    font-weight: 600 !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-process .ant-steps-item-content {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-process .ant-steps-item-rail::after {
    background: rgba(255, 255, 255, 0.3) !important;
  }

  /* FINISH STATE - completed steps */
  .registration-steps-white.ant-steps .ant-steps-item-finish .ant-steps-item-icon {
    background: transparent !important;
    border-color: #ffffff !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-finish .anticon {
    color: #ffffff !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-finish .anticon svg {
    fill: #ffffff !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-finish .ant-steps-item-title {
    color: #ffffff !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-finish .ant-steps-item-content {
    color: rgba(255, 255, 255, 0.7) !important;
  }
  .registration-steps-white.ant-steps .ant-steps-item-finish .ant-steps-item-rail::after {
    background: rgba(255, 255, 255, 0.6) !important;
  }
`;

// Estilo para inverter cores das messages (light mostra dark e vice-versa)
const generateMessageCss = () => `
  /* ============================================= */
  /* Message Inverted Colors - Better Visibility  */
  /* ============================================= */

  /* Light mode - Messages appear with dark background */
  body:not(.body-dark-app) .ant-message .ant-message-notice-content {
    background-color: rgba(0, 0, 0, 0.88) !important;
    color: rgba(255, 255, 255, 0.88) !important;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.2) !important;
  }

  body:not(.body-dark-app) .ant-message .ant-message-notice-content .ant-message-custom-content {
    color: rgba(255, 255, 255, 0.88) !important;
  }

  body:not(.body-dark-app) .ant-message .ant-message-notice-content .ant-message-custom-content > span:last-child {
    color: rgba(255, 255, 255, 0.88) !important;
  }

  /* Dark mode - Messages appear with light background */
  body.body-dark-app .ant-message .ant-message-notice-content {
    background-color: #ffffff !important;
    color: rgba(0, 0, 0, 0.88) !important;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.3) !important;
  }

  body.body-dark-app .ant-message .ant-message-notice-content .ant-message-custom-content {
    color: rgba(0, 0, 0, 0.88) !important;
  }

  body.body-dark-app .ant-message .ant-message-notice-content .ant-message-custom-content > span:last-child {
    color: rgba(0, 0, 0, 0.88) !important;
  }
`;

// Estilos globais de tipografia com suporte a dark mode
const generateTypographyCss = () => `
  /* ============================================= */
  /* Global Typography - Dark Mode Support        */
  /* ============================================= */

  /* Light mode - cores padrão (herda do browser ou usa preto) */
  body:not(.body-dark-app) h1,
  body:not(.body-dark-app) h2,
  body:not(.body-dark-app) h3,
  body:not(.body-dark-app) h4,
  body:not(.body-dark-app) h5,
  body:not(.body-dark-app) h6 {
    color: rgba(0, 0, 0, 0.88);
  }

  body:not(.body-dark-app) p,
  body:not(.body-dark-app) span:not(.anticon):not(.ant-tag):not(.ant-badge-count):not(.ant-btn-icon),
  body:not(.body-dark-app) label,
  body:not(.body-dark-app) li {
    color: rgba(0, 0, 0, 0.88);
  }


  /* Fix: Allow Ant Design Tabs to control their own colors (needs higher specificity) */
  body:not(.body-dark-app) .ant-tabs .ant-tabs-tab .ant-tabs-tab-btn,
  body:not(.body-dark-app) .ant-tabs .ant-tabs-tab .ant-tabs-tab-btn span {
    color: inherit !important;
  }
  body:not(.body-dark-app) .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
  body:not(.body-dark-app) .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn span {
    color: var(--ant-color-primary) !important;
  }
  body:not(.body-dark-app) .ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn,
  body:not(.body-dark-app) .ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn span {
    color: rgba(0, 0, 0, 0.25) !important;
  }

  /* Dark mode - cores claras */
  body.body-dark-app h1,
  body.body-dark-app h2,
  body.body-dark-app h3,
  body.body-dark-app h4,
  body.body-dark-app h5,
  body.body-dark-app h6 {
    color: rgba(255, 255, 255, 0.88);
  }

  body.body-dark-app p,
  body.body-dark-app span:not(.anticon):not(.ant-tag):not(.ant-badge-count),
  body.body-dark-app label,
  body.body-dark-app li {
    color: rgba(255, 255, 255, 0.88);
  }

  /* Fix: Allow Ant Design Tabs to control their own colors (needs higher specificity) */
  body.body-dark-app .ant-tabs .ant-tabs-tab .ant-tabs-tab-btn,
  body.body-dark-app .ant-tabs .ant-tabs-tab .ant-tabs-tab-btn span {
    color: inherit !important;
  }
  body.body-dark-app .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
  body.body-dark-app .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn span {
    color: var(--ant-color-primary) !important;
  }
  body.body-dark-app .ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn,
  body.body-dark-app .ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn span {
    color: rgba(255, 255, 255, 0.25) !important;
  }

  /* Texto secundário/muted */
  body:not(.body-dark-app) .text-muted {
    color: rgba(0, 0, 0, 0.45) !important;
  }

  body.body-dark-app .text-muted {
    color: rgba(255, 255, 255, 0.45) !important;
  }

  /* Texto de descrição */
  body:not(.body-dark-app) .text-secondary,
  body:not(.body-dark-app) .ant-descriptions-item-label {
    color: rgba(0, 0, 0, 0.65);
  }

  body.body-dark-app .text-secondary,
  body.body-dark-app .ant-descriptions-item-label {
    color: rgba(255, 255, 255, 0.65);
  }
`;

// Aplica o CSS dinâmico no <head>
export const applyCustomStyle = currentTheme => {
  const styleId = 'custom-theme-style';
  const primaryColor = app.BASE_THEME.colorPrimary;

  const combinedCss = [
    generateAntdOverrideCss(primaryColor, currentTheme),
    generateCardCss(primaryColor),
    generateTableCss(primaryColor),
    generateFormAvatarCss(primaryColor),
    generateKanbanCss(primaryColor),
    generateNotificationProgressCss(primaryColor),
    generateMessageCss(),
    // generateStepsCss(primaryColor),
    // generateTypographyCss(),
  ].join('\n');

  let style = document.getElementById(styleId);

  if (!style) {
    style = document.createElement('style');
    style.id = styleId;
    document.head.appendChild(style);
  }

  style.textContent = combinedCss;
};
